export enum HelpFormRoutingEnum {
  Landing = '',
  Player = 'form',
  PlayerEdition = 'form/:questionId',
  Summary = 'summary',
}
